import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';
import InfrastructureElementTableDto from '../dto/InfrastructureElementTableDto';

class InfrastructureElementTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'infrastructureElementTableControl';
	}

	/**
	 * @param {string} session
	 * @param {number} firstResult
	 * @param {number} maxResults
	 * @return {Promise<GenericTableDto<InfrastructureElementTableDto>>}
	 */
	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, InfrastructureElementTableDto)))
				.catch(reject);
		});
	}
}

export default new InfrastructureElementTableService();
